import { z } from 'zod'

export const refreshTokenSchema = z.object({
  /** refresh token */
  refreshToken: z.string()
})

export interface RefreshToken extends z.infer<typeof refreshTokenSchema> {}
